import Server from '@/api/server'
import serverUrl from '@/api/serverUrl'

const app = {
  state: {
    sid: '',
    terminal: {},
    orderList: {},
    orderInfo: {},
    distance: '',
    popShow: false,
    popShow1: false,
    searchMain: ''
  },
  mutations: {
    setSid: (state, data) => {
      state.sid = data
    },
    getOrderInfo: (state, data) => {
      state.orderInfo = data
    },
    getOrderList: (state, data) => {
      if (data.list) {
        if (data.pageIndex === 1) {
          state.orderList = data
        } else {
          state.orderList.pageIndex = data.pageIndex
          state.orderList.actuaCount = data.actuaCount
          state.orderList.total = data.total
          state.orderList.pageSize = data.pageSize
          state.orderList.list.push(...data.list)
        }
      } else {
        state.orderList.pageIndex = 1
        state.orderList.actuaCount = 1
        state.orderList.total = 1
        state.orderList.pageSize = 10
        state.orderList.list = []
        state.orderList.list.push(data)
      }
      console.log('--------');
      console.log(state.orderList);
      console.log('--------');
    },
    addTerminal: (state, data) => {
      state.terminal = data
    },
    setDistance: (state, data) => {
      state.distance = data
    },
    setSearchMain: (state, data) => {
      state.searchMain = data
    },
    setPopShow: (state, data) => {
      state.popShow = data
    },
    setPopShow1: (state, data) => {
      state.popShow1 = data
    }
  },
  actions: {
    amapAdd({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.amapAdd, data, 'post').then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAmapList({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getAmapList, data, 'get').then(response => {
          const data = response.data
          commit('setSid', data.data.results[0].sid)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLastpoint({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getLastpoint, data, 'get').then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    addTerminal({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.addTerminal, data, 'post').then(response => {
          const data = response.data
          commit('addTerminal', data.data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    addTrace({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.addTrace, data, 'post').then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    uploadPoint({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.uploadPoint, data, 'post').then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询地址信息
    selectDriverPositionById({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.selectDriverPositionById, data, 'post').then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取订单列表
    getOrderList({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getOrderList, data, 'post').then(response => {
          const data = response.data
          commit('getOrderList', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 订单详情查询
    getOrderInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getOrderInfo, data, 'post').then(response => {
          const data = response.data
          commit('getOrderInfo', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据id获取版本
    getTerminalVersionInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getTerminalVersionInfo, data, 'post').then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 跟剧组获取版本
    getTerminalVersionListByGroup({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getTerminalVersionListByGroup, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登陆
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.login, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 共享链接客户注册
    register({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.register, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    customerActRegister({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.customerActRegister, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 共享链接司机注册
    activityregister({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.activityregister, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    driverActRegister({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.driverActRegister, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 客户向客户推荐的排行榜
    getCustomerRecommendRankingList({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getCustomerRecommendRankingList, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 司机向司机推荐的排行榜
    getDriverRecommendRankingList({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getDriverRecommendRankingList, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询司机推荐信息
    selectActDriverRe({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.selectActDriverRe, data, 'get').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询客户推荐信息
    selectActCustomerRe({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.selectActCustomerRe, data, 'get').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 短信验证码
    sendSms({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.sendSms, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 员工邀请客户
    empRecomCustomer({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.empRecomCustomer, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 员工邀请司机
    empRecomDriver({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.empRecomDriver, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 公众号支付
    unOrder({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.unOrder, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 待支付代付订单
    findPayOrder({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.findPayOrder, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // H5页面价格查询
    h5PageQuery({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.h5PageQuery, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取高德路径规划
    getGaoDeDriving({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getGaoDeDriving, data, 'get').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取签名
    getSignature({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getSignature, data, 'post').then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取保费数据
    getAllInsureConfigList({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.getAllInsureConfigList, data, 'post').then(response => {
          // console.log(response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 微信朋友圈
    friendscircle({ commit }, data) {
      return new Promise((resolve, reject) => {
        Server.DataAjax(serverUrl.friendscircle, data, 'post').then(response => {
          // console.log(response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js